<template>

	<div >
		<template v-if="device!='pc'">
			<van-popup :overlay="false" :duration="0.01" :transition-appear="true" v-model="model" @opened="show" @closed="hide" position="right" :style="{ width: '100%',height: '100%' }" style="overflow:hidden;">
				<windowmodal ref="windowmodal" v-bind="$props" @load="windowmodalLoad" @forward="forward" :safe-area-inset-bottom="true">
					<template #title>
						<slot name='title'></slot>
					</template>
					<template #main>
						<div style="padding: 0px 10px;margin-top: 20px;">
							<slot name='main'></slot>
						</div>
					</template>
					<template #footer>
						<slot name='footer'></slot>
					</template>
					<template #load>
						<transition name="el-fade-in-linear">
							<div class="full flex form_loading" v-if="loading"
								style="background-color: rgba(255, 255, 255, 0.5);z-index: 999;color: #409EFF;">
								<i class="el-icon-loading"></i>
								<span style="font-size: 14px;">请等待</span>
							</div>
						</transition>
					</template>
				</windowmodal>
			</van-popup>
		</template>
		<template v-else>
			<template v-if="windowType=='modal'">
				<vxe-modal size="mini" v-model="model" :width="width" :height="height" show-footer destroy-on-close show-zoom
					@hide="hide" transfer :lock-scroll="false" :showHeader="true" :loading="loading" @show="show">
					<template #title>
						<slot name='title'></slot>
					</template>
					<template #default>
						<div style="padding: 0px 10px;margin-top: 30px;">
							<slot name='main'></slot>
						</div>
					</template>
					<template #footer>
						<slot name='footer'></slot>
					</template>
				</vxe-modal>
			</template>
			<template v-else>
				<windowmodal ref="windowmodal" v-bind="$props" @load="windowmodalLoad" @forward="forward">
					<template #title>
						<slot name='title'></slot>
					</template>
					<template #main>
						<div style="padding: 0px 10px;margin-top: 20px;">
							<slot name='main'></slot>
						</div>
					</template>
					<template #footer>
						<slot name='footer'></slot>
					</template>
					<template #load>
						<transition name="el-fade-in-linear">
							<div class="full flex form_loading" v-if="loading"
								style="background-color: rgba(255, 255, 255, 0.5);z-index: 999;color: #409EFF;">
								<i class="el-icon-loading"></i>
								<span style="font-size: 14px;">请等待</span>
							</div>
						</transition>
					</template>
				</windowmodal>
			</template>
			<slot name='other'></slot>
		</template>
	</div>


</template>
<style>

</style>
<script>
	import windowmodal from '@_system/components/forms/window/windowmodal.vue'
	export default {
		props: {
			mainForm: {
				default: () => {
					return null
				}
			},
			id: {
				type: [Number, String],
				default: () => {
					return 0
				}
			},
			name: {
				type: String,
				default: () => {
					return ''
				}
			},
			windowType: {
				type: String,
				default: () => {
					return 'modal'
				}
			},
			width: {
				type: [Number, String],
				default: () => {
					return 800
				}
			},
			height: {
				type: [Number, String],
				default: () => {
					return 800
				}
			},
			loading: {
				type: Boolean,
				default: () => {
					return false
				}
			},
			flowprogressid: {
				type: [Number, String],
				default: () => {
					return 0
				}
			},
			flowid: {
				type: [Number, String],
				defalut: () => {
					return 0
				}
			},
			controlltype: {
				type: [Number, String],
				default: () => {
					return 1
				}
			},
			isflow: {
				type: [Number, String],
				defalut: () => {
					return 0
				}
			},
			device: {
				type: [String],
				default: () => {
					return window.systemMethods.device()
				}
			},
		},
		data() {
			return {
				//loading:true,
				model: false,
				backtype: null,
			}

		},

		watch: {

		},
		computed: {

		},
		created() {

		},
		mounted() {

		},

		methods: {
			modalShow() {
				this.model = true
			},
			modalHide(type) {
				this.backtype = type
				this.model = false
			},
			setLoading(value) {
				this.loading = value
			},
			show() {
				this.$emit('show')
			},
			hide() {
				this.$emit('hide', this.backtype?this.backtype:'cancle')
			},
			windowmodalLoad() {
				this.$emit('windowmodalLoad', {
					windowModal: this.$refs.windowmodal
				})
			},
			forward(e){
				this.$emit('forward',e)
			}

		},
		components: {
			windowmodal
		}
	}
</script>
